import styled, { css } from '../theme/styled';
import { MessageVariant, StyledMessageProps } from './message.types';
import type { DSScaledColors } from '../theme';

export const iconColors: Record<MessageVariant, keyof DSScaledColors> = {
  info: 'primary',
  success: 'green',
  warning: 'orange',
  error: 'red',
  pending: 'primary',
};

export const StyledMessage = styled.div<StyledMessageProps>`
  ${({ theme, $type }) => css`
    padding-block: ${theme.spacings.componentOnly};
    padding-inline: ${theme.spacings.s};
    display: flex;
    align-items: center;
    gap: ${theme.spacings.xs};
    color: ${theme.colors.gray[800]};
    background-color: ${theme.colors.white};
    border: 1px solid ${theme.colors.gray[200]};
    border-radius: ${theme.radiuses.xs};
    box-shadow: ${theme.shadows.sm};
    user-select: none;

    & .svg-viewer {
      color: ${theme.colors[iconColors[$type]][400]};
    }
  `};
`;
